import { fetchAcademyApi } from '../../services/academy-api'

export const apiCreateFootprint = async footprint => {
  const url = `/create-footprint`
  return fetchAcademyApi(url, {
    method: 'POST',
    body: JSON.stringify(footprint)
  })
}



// WEBPACK FOOTER //
// ./src/containers/UserEvents/services.js